
  import {Vue, Component, Prop} from "vue-property-decorator";

  import storage from "@/services/storage";
  import {User} from "@/interface";
  import { hslColorFromName } from "@/utils/hslColorFromName";

  @Component
  export default class PageHeadAvatar extends Vue {
    @Prop({type: String, default: ""}) readonly avatar!: string;
    @Prop({type: Object, required: true}) readonly user!: User;

    filepath: string | null = null;
    

    get initial(): string {
      const firstName = this.user?.given_name;
      const lastName = this.user?.family_name;

      if (!firstName && !lastName) {
        return ''
      }

      const givenName = firstName ? firstName.trimLeft()[0] : '';
      const familyName = lastName ? lastName.trimLeft()[0] : '';
      return `${givenName}${familyName}`;
    }

    get bgStyle(): object {
        return {
            background: hslColorFromName(this.initial || ""),
        };
    }

    async mounted(): Promise<void> {
      await this.loadImage();
    }

    async updated(): Promise<void> {
      await this.loadImage();
    }

    async loadImage(): Promise<void> {
      if (this.avatar) {
        this.filepath = await storage.get(this.avatar);
      }
    }
  }
